import { Box } from "@mui/material";
import { useCallback, useMemo } from "react";
import { AutocompleteArrayInput, useTranslate } from "react-admin";

export const RaAutocompleteArrayInput = ({ label, field, optionText, ...props }) => {
    const translate = useTranslate();

    const inputText = useCallback(
        (choice) => {
            return choice?.[field] || "";
        },
        [field]
    );

    const OptionText = useCallback(
        (option) => {
            return (
                <Box sx={{ width: "100%" }} title={option[field]}>
                    {optionText ? optionText(option) : option[field]}
                </Box>
            );
        },
        [field, optionText]
    );

    const filterToQuery = useMemo(
        (searchText) => ({
            [field]: searchText,
        }),
        [field]
    );

    const translatedLabel = useMemo(() => translate(label), [translate, label]);

    return (
        <AutocompleteArrayInput
            label={label}
            title={translatedLabel}
            optionText={OptionText}
            inputText={inputText}
            filterToQuery={filterToQuery}
            {...props}
        />
    );
};
